import _objectSpread from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { valsubstr32addbr } from '@/utils';
import NoData from '@/components/NoData/NoData';
import manage from '@/constants/manage';
export default {
  components: {
    NoData: NoData
  },
  name: 'preViewRule',
  data: function data() {
    return {
      formInline: {
        userId: '',
        jobCodeList: [],
        orgIdList: [],
        businessLineList: []
      },
      showLoading: false,
      tableData: [],
      tableheight: 600,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      isEdit: 0,
      isAdd: 0,
      userOptionLoading: false,
      userOptions: [],
      jobList: [],
      dictList: JSON.parse(sessionStorage.getItem('dist_info')),
      buslinList: [],
      ruleList: null,
      ruleName: '',
      topId: manage.HEAD_ORG_ID
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.tableheight = window.innerHeight - 332;

      // 监听窗口大小变化
      var self = this;
      window.onresize = function () {
        self.tableheight = window.innerHeight - 332;
      };
    });
  },
  created: function created() {
    this.dictInfo = this.dictList.BUSINESS_LINE || null;
    if (this.dictInfo !== null) {
      // eslint-disable-next-line guard-for-in
      for (var i in this.dictInfo) {
        this.buslinList.push({
          key: i,
          value: this.dictInfo[i]
        });
      }
    }
    this.isEdit = this.$route.params.isEdit;
    this.ruleName = this.$route.params.ruleName;
    this.isAdd = this.$route.params.isAdd;
    this.init();
  },
  methods: {
    resetSearch: function resetSearch() {
      this.formInline = {
        userId: '',
        jobCodeList: [],
        orgIdList: [],
        businessLineList: []
      };
      this.pageNum = 1;
      this.pageSize = 10;
      this.getUserData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNum = val;
      this.getUserData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getUserData();
    },
    getUserData: function getUserData() {
      var _this = this;
      this.$API.postRequest({
        url: '/platform/userRule/previewRule',
        data: _objectSpread(_objectSpread({}, this.formInline), {}, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          userLabelSubRuleDTOList: this.ruleList.userLabelSubRuleList || []
        })
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this.total = res.result.total;
          _this.tableData = res.result.records;
        }
      });
    },
    userRemoteMethod: function userRemoteMethod(val) {
      var _this2 = this;
      if (val === '') {
        return;
      }
      this.userOptionLoading = true;
      this.$API.getRequest({
        url: "/platform/component/userNameOrId/".concat(val),
        data: {}
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this2.userOptions = res.result;
        }
      }).finally(function () {
        _this2.userOptionLoading = false;
      });
    },
    reback: function reback() {
      this.$router.push({
        name: 'editRule',
        query: {
          isEdit: this.isEdit,
          isAdd: this.isAdd
        }
      });
    },
    init: function init() {
      var _this3 = this;
      this.ruleList = this.$store.state.system.ruleInfo;
      this.$API.postRequest({
        url: '/platform/userRule/previewRule',
        data: {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          userLabelSubRuleDTOList: this.ruleList.userLabelSubRuleList || []
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this3.tableData = res.result.records;
          _this3.total = res.result.total;
        }
      });
      this.$API.getRequest({
        url: '/platform/job/allJob'
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this3.jobList = res.result;
        }
      });
    },
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    },
    headerdragend: function headerdragend(newWidth, oldWidth, column) {
      if (newWidth < column.minWidth) {
        column.width = column.minWidth;
      }
    }
  }
};